export const tragoProducts = [
  // === 1페이지: HDB001~HDB014 ===
  {
    id: 'HDB001',
    name: 'HDB001',
    partNumber: '92101-7C000 L / 92102-7C000 R',
    description: 'HEAD LAMP',
    price: 98000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '램프',
    vehicleBrand: 'HYUNDAI',
    image: 'https://public.readdy.ai/ai/img_res/3a363cfdfd5cb828f5f854308547620e.jpg',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Trago%20heavy%20truck%20headlamp%20clear%20lens%20large%20rectangular%20chrome%20housing%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional%20shot%20detailed&width=800&height=800&seq=hdb001main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=heavy%20truck%20headlight%20clear%20lens%20large%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb001img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '24V',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 헤드램프입니다. 품번 L:92101-7C000 / R:92102-7C000.',
    colors: ['#FFFFFF'],
    features: [
      { icon: 'ri-lightbulb-line', title: '고휘도 조명', description: '야간 시인성 향상' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환성' },
      { icon: 'ri-water-flash-line', title: '방수 설계', description: '우천 시 안전' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20headlamp%20quality%20testing%20laboratory%20clean%20environment%20professional%20lighting&width=1200&height=800&seq=hdb001craft&orientation=landscape',
      story: '트라고 트럭의 안전한 야간 운행을 위한 고품질 헤드램프입니다.',
      details: ['순정 규격 제작', '24V 전용', '내구성 강화 렌즈', '방수 처리 완료'],
    },
  },
  {
    id: 'HDB002',
    name: 'HDB002',
    partNumber: '92201-7C000 L / 92202-7C000 R',
    description: 'CORNER LAMP',
    price: 42000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '램프',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20corner%20lamp%20clear%20lens%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb002main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20corner%20lamp%20clear%20lens%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb002main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20corner%20signal%20light%20clear%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb002img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '24V',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 코너램프입니다. 품번 L:92201-7C000 / R:92202-7C000.',
    colors: ['#FFFFFF'],
    features: [
      { icon: 'ri-lightbulb-line', title: '선명한 신호', description: '안전한 방향지시' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-eye-line', title: '높은 시인성', description: '주야간 선명' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20signal%20lamp%20production%20clean%20factory%20professional%20lighting&width=1200&height=800&seq=hdb002craft&orientation=landscape',
      story: '트라고 트럭의 안전한 방향 전환을 위한 코너램프입니다.',
      details: ['투명 렌즈', '순정 규격 일치', '빠른 점멸 반응', '내구성 보장'],
    },
  },
  {
    id: 'HDB003',
    name: 'HDB003',
    partNumber: '92303-7A000 L / 92304-7A000 R',
    description: 'AUTO LAMP',
    price: 48000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '램프',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20auto%20lamp%20clear%20lens%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb003main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20auto%20lamp%20clear%20lens%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb003main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20auto%20light%20clear%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb003img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '24V',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 오토램프입니다. 품번 L:92303-7A000 / R:92304-7A000.',
    colors: ['#FFFFFF'],
    features: [
      { icon: 'ri-lightbulb-line', title: '자동 점등', description: '편리한 사용' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-eye-line', title: '높은 시인성', description: '주야간 선명' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20lamp%20production%20clean%20factory%20professional%20lighting&width=1200&height=800&seq=hdb003craft&orientation=landscape',
      story: '트라고 트럭의 안전한 운행을 위한 오토램프입니다.',
      details: ['자동 점등 기능', '순정 규격 준수', '내구성 강화', '방수 처리 완료'],
    },
  },
  {
    id: 'HDB004',
    name: 'HDB004',
    partNumber: '92303-7M000 L / 92304-7M000 R',
    description: 'AUTO LAMP',
    price: 48000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '램프',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20auto%20lamp%20clear%20lens%20modern%20design%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb004main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20auto%20lamp%20clear%20lens%20modern%20design%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb004main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20auto%20light%20modern%20clear%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb004img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '24V',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 오토램프입니다. 품번 L:92303-7M000 / R:92304-7M000.',
    colors: ['#FFFFFF'],
    features: [
      { icon: 'ri-lightbulb-line', title: '자동 점등', description: '편리한 사용' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-eye-line', title: '높은 시인성', description: '주야간 선명' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20lamp%20production%20clean%20factory%20professional%20lighting&width=1200&height=800&seq=hdb004craft&orientation=landscape',
      story: '트라고 트럭의 안전한 운행을 위한 오토램프입니다.',
      details: ['자동 점등 기능', '순정 규격 준수', '내구성 강화', '방수 처리 완료'],
    },
  },
  {
    id: 'HDB005',
    name: 'HDB005',
    partNumber: '92660-7A900',
    description: 'SIDE LAMP',
    price: 28000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '램프',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20side%20lamp%20clear%20lens%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb005main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20side%20lamp%20clear%20lens%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb005main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20side%20light%20clear%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb005img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '24V',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 사이드램프입니다. 품번 92660-7A900.',
    colors: ['#FFFFFF'],
    features: [
      { icon: 'ri-lightbulb-line', title: '측면 조명', description: '안전 확보' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-eye-line', title: '높은 시인성', description: '주야간 선명' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20side%20lamp%20production%20clean%20factory%20professional%20lighting&width=1200&height=800&seq=hdb005craft&orientation=landscape',
      story: '트라고 트럭의 측면 안전을 위한 사이드램프입니다.',
      details: ['측면 시인성 강화', '순정 규격 준수', '내구성 강화', '방수 처리 완료'],
    },
  },
  {
    id: 'HDB006',
    name: 'HDB006',
    partNumber: '92401-7A100 L / 92402-7A100 R',
    description: 'AUTO LAMP',
    price: 52000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '램프',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20auto%20tail%20lamp%20red%20amber%20clear%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb006main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20auto%20tail%20lamp%20red%20amber%20clear%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb006main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20tail%20light%20red%20amber%20clear%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb006img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '24V',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 오토램프입니다. 품번 L:92401-7A100 / R:92402-7A100.',
    colors: ['#FF0000'],
    features: [
      { icon: 'ri-lightbulb-line', title: '후방 조명', description: '안전 확보' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-eye-line', title: '높은 시인성', description: '주야간 선명' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20tail%20lamp%20production%20clean%20factory%20professional%20lighting&width=1200&height=800&seq=hdb006craft&orientation=landscape',
      story: '트라고 트럭의 후방 안전을 위한 오토램프입니다.',
      details: ['후방 시인성 강화', '순정 규격 준수', '내구성 강화', '방수 처리 완료'],
    },
  },
  {
    id: 'HDB006LED',
    name: 'HDB006LED',
    partNumber: 'HDB006LED',
    description: 'TAIL LAMP LED',
    price: 72000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '램프',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20LED%20tail%20lamp%20red%20amber%20clear%20modern%20design%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb006ledmain&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20LED%20tail%20lamp%20red%20amber%20clear%20modern%20design%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb006ledmain&orientation=squarish',
      'https://readdy.ai/api/search-image?query=LED%20truck%20tail%20light%20red%20amber%20clear%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb006ledimg1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '24V',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 LED 테일램프입니다. 적색/주황/투명 LED 타입으로 밝고 선명합니다.',
    colors: ['#FF0000'],
    features: [
      { icon: 'ri-lightbulb-line', title: 'LED 조명', description: '초고휘도' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-flashlight-line', title: '저전력', description: '에너지 절약' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=LED%20truck%20lamp%20testing%20facility%20clean%20environment%20professional%20lighting&width=1200&height=800&seq=hdb006ledcraft&orientation=landscape',
      story: '트라고 트럭의 후방 안전을 위한 최신 LED 테일램프입니다.',
      details: ['LED 초고휘도', '저전력 소비', '장수명 설계', '방수 처리 완료'],
    },
  },
  {
    id: 'HDB007',
    name: 'HDB007',
    partNumber: '92650-7M000 L / 92660-7M000 R',
    description: 'SIDE LAMP',
    price: 32000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '램프',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20side%20lamp%20clear%20lens%20pair%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb007main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20side%20lamp%20clear%20lens%20pair%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb007main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20side%20light%20pair%20clear%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb007img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '24V',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 사이드램프입니다. 품번 L:92650-7M000 / R:92660-7M000.',
    colors: ['#FFFFFF'],
    features: [
      { icon: 'ri-lightbulb-line', title: '측면 조명', description: '안전 확보' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-eye-line', title: '높은 시인성', description: '주야간 선명' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20side%20lamp%20production%20clean%20factory%20professional%20lighting&width=1200&height=800&seq=hdb007craft&orientation=landscape',
      story: '트라고 트럭의 측면 안전을 위한 사이드램프입니다.',
      details: ['측면 시인성 강화', '순정 규격 준수', '내구성 강화', '방수 처리 완료'],
    },
  },
  {
    id: 'HDB008',
    name: 'HDB008',
    partNumber: '71535-7C000',
    description: 'GRILLE',
    price: 58000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20front%20grille%20black%20large%20with%20horizontal%20slats%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb008main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20front%20grille%20black%20large%20with%20horizontal%20slats%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb008main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20grille%20black%20large%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb008img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 그릴입니다. 품번 71535-7C000.',
    colors: ['#000000'],
    features: [
      { icon: 'ri-car-line', title: '순정 디자인', description: '오리지널 스타일' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-sun-line', title: 'UV 내성', description: '변색 방지' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '클립 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20grille%20production%20line%20clean%20factory%20professional%20lighting&width=1200&height=800&seq=hdb008craft&orientation=landscape',
      story: '트라고 트럭의 프론트 외관을 복원하는 순정 그릴입니다.',
      details: ['블랙 마감', '고강도 플라스틱', 'UV 코팅', '정확한 규격'],
    },
  },
  {
    id: 'HDB009',
    name: 'HDB009',
    partNumber: '86310-7C000',
    description: 'GRILLE',
    price: 68000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20front%20grille%20black%20large%20mesh%20design%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb009main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20front%20grille%20black%20large%20mesh%20design%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb009main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20grille%20black%20mesh%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb009img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 그릴입니다. 품번 86310-7C000.',
    colors: ['#000000'],
    features: [
      { icon: 'ri-car-line', title: '순정 디자인', description: '오리지널 스타일' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-sun-line', title: 'UV 내성', description: '변색 방지' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '클립 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20grille%20production%20line%20clean%20factory%20professional%20lighting&width=1200&height=800&seq=hdb009craft&orientation=landscape',
      story: '트라고 트럭의 프론트 외관을 복원하는 순정 그릴입니다.',
      details: ['블랙 마감', '고강도 플라스틱', 'UV 코팅', '정확한 규격'],
    },
  },
  {
    id: 'HDB010',
    name: 'HDB010',
    partNumber: '71535-7C100',
    description: 'GRILLE',
    price: 68000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20front%20grille%20black%20large%20with%20horizontal%20slats%20updated%20design%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb010main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20front%20grille%20black%20large%20with%20horizontal%20slats%20updated%20design%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb010main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20grille%20black%20updated%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb010img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 그릴입니다. 품번 71535-7C100.',
    colors: ['#000000'],
    features: [
      { icon: 'ri-car-line', title: '순정 디자인', description: '오리지널 스타일' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-sun-line', title: 'UV 내성', description: '변색 방지' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '클립 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20grille%20production%20line%20clean%20factory%20professional%20lighting&width=1200&height=800&seq=hdb010craft&orientation=landscape',
      story: '트라고 트럭의 프론트 외관을 복원하는 순정 그릴입니다.',
      details: ['블랙 마감', '고강도 플라스틱', 'UV 코팅', '정확한 규격'],
    },
  },
  {
    id: 'HDB011',
    name: 'HDB011',
    partNumber: '86310-7C100',
    description: 'GRILLE',
    price: 68000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20front%20grille%20black%20large%20mesh%20design%20updated%20version%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb011main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20front%20grille%20black%20large%20mesh%20design%20updated%20version%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb011main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20grille%20black%20mesh%20updated%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb011img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 그릴입니다. 품번 86310-7C100.',
    colors: ['#000000'],
    features: [
      { icon: 'ri-car-line', title: '순정 디자인', description: '오리지널 스타일' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-sun-line', title: 'UV 내성', description: '변색 방지' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '클립 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20grille%20production%20line%20clean%20factory%20professional%20lighting&width=1200&height=800&seq=hdb011craft&orientation=landscape',
      story: '트라고 트럭의 프론트 외관을 복원하는 순정 그릴입니다.',
      details: ['블랙 마감', '고강도 플라스틱', 'UV 코팅', '정확한 규격'],
    },
  },
  {
    id: 'HDB012',
    name: 'HDB012',
    partNumber: '86310-7J000',
    description: 'GRILLE',
    price: 68000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20front%20grille%20black%20large%20with%20horizontal%20slats%20new%20model%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb012main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20front%20grille%20black%20large%20with%20horizontal%20slats%20new%20model%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb012main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20grille%20black%20new%20model%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb012img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 그릴입니다. 품번 86310-7J000.',
    colors: ['#000000'],
    features: [
      { icon: 'ri-car-line', title: '순정 디자인', description: '오리지널 스타일' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-sun-line', title: 'UV 내성', description: '변색 방지' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '클립 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20grille%20production%20line%20clean%20factory%20professional%20lighting&width=1200&height=800&seq=hdb012craft&orientation=landscape',
      story: '트라고 트럭의 프론트 외관을 복원하는 순정 그릴입니다.',
      details: ['블랙 마감', '고강도 플라스틱', 'UV 코팅', '정확한 규격'],
    },
  },
  {
    id: 'HDB013',
    name: 'HDB013',
    partNumber: '71535-7J000',
    description: 'GRILLE',
    price: 58000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20front%20grille%20black%20large%20with%20horizontal%20slats%20new%20model%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb013main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20front%20grille%20black%20large%20with%20horizontal%20slats%20new%20model%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb013main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20grille%20black%20new%20model%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb013img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 그릴입니다. 품번 71535-7J000.',
    colors: ['#000000'],
    features: [
      { icon: 'ri-car-line', title: '순정 디자인', description: '오리지널 스타일' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-sun-line', title: 'UV 내성', description: '변색 방지' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '클립 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20grille%20production%20line%20clean%20factory%20professional%20lighting&width=1200&height=800&seq=hdb013craft&orientation=landscape',
      story: '트라고 트럭의 프론트 외관을 복원하는 순정 그릴입니다.',
      details: ['블랙 마감', '고강도 플라스틱', 'UV 코팅', '정확한 규격'],
    },
  },
  {
    id: 'HDB014',
    name: 'HDB014',
    partNumber: '82710-7M500 L / 82720-7M500 R',
    description: 'CORNER PANEL',
    price: 88000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20corner%20panel%20white%20plastic%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb014main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20corner%20panel%20white%20plastic%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb014main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20corner%20panel%20white%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb014img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 코너패널입니다. 품번 L:82710-7M500 / R:82720-7M500.',
    colors: ['#FFFFFF'],
    features: [
      { icon: 'ri-car-line', title: '순정 디자인', description: '오리지널 스타일' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-sun-line', title: 'UV 내성', description: '변색 방지' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20panel%20production%20facility%20clean%20environment%20professional%20lighting&width=1200&height=800&seq=hdb014craft&orientation=landscape',
      story: '트라고 트럭의 외관을 복원하는 순정 코너패널입니다.',
      details: ['순정 규격 제작', '고강도 플라스틱', 'UV 코팅', '정확한 규격'],
    },
  },

  // === 2페이지: HDB015~HDB023, HDB025~HDB026, HDB038~HDB040 ===
  {
    id: 'HDB015',
    name: 'HDB015',
    partNumber: '82710-7M600 L / 82720-7M600 R',
    description: 'CORNER PANEL',
    price: 82000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20corner%20panel%20white%20plastic%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb015main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20corner%20panel%20white%20plastic%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb015main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20corner%20panel%20white%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb015img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 코너패널입니다. 품번 L:82710-7M600 / R:82720-7M600.',
    colors: ['#FFFFFF'],
    features: [
      { icon: 'ri-car-line', title: '순정 디자인', description: '오리지널 스타일' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-sun-line', title: 'UV 내성', description: '변색 방지' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20panel%20production%20facility%20clean%20environment%20professional%20lighting&width=1200&height=800&seq=hdb015craft&orientation=landscape',
      story: '트라고 트럭의 외관을 복원하는 순정 코너패널입니다.',
      details: ['순정 규격 제작', '고강도 플라스틱', 'UV 코팅 처리', '정확한 규격'],
    },
  },
  {
    id: 'HDB016',
    name: 'HDB016',
    partNumber: '86940-7C000 L / 86950-7C000 R',
    description: 'MUD GUARD',
    price: 35000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20mud%20guard%20black%20rubber%20flap%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb016main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20mud%20guard%20black%20rubber%20flap%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb016main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20mud%20flap%20black%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb016img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 머드가드입니다. 품번 L:86940-7C000 / R:86950-7C000.',
    colors: ['#000000'],
    features: [
      { icon: 'ri-shield-check-line', title: '비산 방지', description: '돌 튀김 차단' },
      { icon: 'ri-water-flash-line', title: '방수 소재', description: '내구성 우수' },
      { icon: 'ri-sun-line', title: '내후성', description: '전천후 사용' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20mud%20guard%20manufacturing%20clean%20factory%20professional%20lighting&width=1200&height=800&seq=hdb016craft&orientation=landscape',
      story: '트라고 트럭의 차체를 보호하는 고품질 머드가드입니다.',
      details: ['고무 소재', '비산 방지', '내후성 강화', '순정 규격'],
    },
  },
  {
    id: 'HDB017',
    name: 'HDB017',
    partNumber: '86940-7M000 L / 86950-7M000 R',
    description: 'MUD GUARD',
    price: 35000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20mud%20guard%20black%20rubber%20large%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb017main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20mud%20guard%20black%20rubber%20large%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb017main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=large%20truck%20mud%20flap%20black%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb017img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 머드가드입니다. 품번 L:86940-7M000 / R:86950-7M000.',
    colors: ['#000000'],
    features: [
      { icon: 'ri-shield-check-line', title: '비산 방지', description: '돌 튀김 차단' },
      { icon: 'ri-water-flash-line', title: '방수 소재', description: '내구성 우수' },
      { icon: 'ri-sun-line', title: '내후성', description: '전천후 사용' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20mud%20guard%20production%20clean%20factory%20professional%20lighting&width=1200&height=800&seq=hdb017craft&orientation=landscape',
      story: '트라고 트럭의 차체를 보호하는 고품질 머드가드입니다.',
      details: ['고무 소재', '비산 방지', '내후성 강화', '순정 규격'],
    },
  },
  {
    id: 'HDB018',
    name: 'HDB018',
    partNumber: '86851-7C000 L / 86861-7C000 R',
    description: 'MUD GUARD',
    price: 45000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=professional%20automotive%20mud%20guard%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20rear%20wheel%20protection%20component%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts&width=800&height=800&seq=hdb018mudguard&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=professional%20automotive%20mud%20guard%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20rear%20wheel%20protection%20component%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts&width=800&height=800&seq=hdb018mudguard&orientation=squarish',
      'https://readdy.ai/api/search-image?query=professional%20automotive%20mud%20guard%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20rear%20wheel%20protection%20component%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts%20angle%20view&width=800&height=800&seq=hdb018mudguard2&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: 'HYUNDAI TRAGO HD170-1000 HD-260 전용 머드가드입니다. 리어 휠 보호를 위한 고품질 부품으로, 내구성이 뛰어나며 완벽한 핏을 제공합니다.',
    colors: ['#000000'],
    features: [
      { icon: 'ri-shield-check-line', title: '내구성', description: '고품질 소재 사용' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '순정 규격 완벽 호환' },
      { icon: 'ri-checkbox-circle-line', title: '품질 보증', description: '엄격한 품질 검사' },
      { icon: 'ri-truck-line', title: '빠른 배송', description: '신속한 배송 서비스' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=modern%20automotive%20parts%20manufacturing%20facility%20quality%20control%20inspection%20process%20for%20heavy%20duty%20truck%20components%20professional%20industrial%20environment%20Korean%20factory&width=1200&height=800&seq=hdb018story&orientation=landscape',
      story: 'HYUNDAI TRAGO HD170-1000 HD-260 전용 머드가드는 엄격한 품질 관리를 거쳐 생산됩니다. 내구성과 완벽한 핏을 보장하는 고품질 부품입니다.',
      details: ['순정 규격에 맞춘 정밀 제작', '내구성 테스트 완료', '완벽한 차량 호환성', '장기간 사용 가능한 고품질 소재'],
    },
  },
  {
    id: 'HDB019',
    name: 'HDB019',
    partNumber: '82330-7C000 L / 82340-7C000 R',
    description: 'HANDLE',
    price: 45000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20door%20handle%20black%20metal%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb019main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20door%20handle%20black%20metal%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb019main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20door%20handle%20black%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb019img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 핸들입니다. 품번 L:82330-7C000 / R:82340-7C000.',
    colors: ['#000000'],
    features: [
      { icon: 'ri-hand-line', title: '편리한 그립', description: '인체공학 설계' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-sun-line', title: '내후성', description: '전천후 사용' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20handle%20manufacturing%20clean%20factory%20professional%20lighting&width=1200&height=800&seq=hdb019craft&orientation=landscape',
      story: '트라고 트럭의 편리한 승하차를 위한 핸들입니다.',
      details: ['인체공학 설계', '고강도 소재', '순정 규격 제작', '내후성 강화'],
    },
  },
  {
    id: 'HDB020',
    name: 'HDB020',
    partNumber: '86510-7C000 L / 86520-7C000 R',
    description: 'FRONT BUMPER',
    price: 180000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20front%20bumper%20orange%20painted%20metal%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb020main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20front%20bumper%20orange%20painted%20metal%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb020main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20bumper%20orange%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb020img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 프론트 범퍼입니다. 품번 L:86510-7C000 / R:86520-7C000.',
    colors: ['#FF8C00'],
    features: [
      { icon: 'ri-car-line', title: '고강도 소재', description: '내충격성 우수' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-sun-line', title: 'UV 내성', description: '변색 방지' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20bumper%20manufacturing%20facility%20clean%20environment%20professional%20lighting&width=1200&height=800&seq=hdb020craft&orientation=landscape',
      story: '트라고 트럭의 프론트를 보호하는 고강도 범퍼입니다.',
      details: ['고강도 금속', '순정 규격 제작', '도장 처리', '내충격 설계'],
    },
  },
  {
    id: 'HDB021',
    name: 'HDB021',
    partNumber: '86331-7C000 L / 86341-7C000 R',
    description: 'CORNER PANEL',
    price: 75000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20corner%20panel%20white%20plastic%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb021main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20corner%20panel%20white%20plastic%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb021main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20corner%20panel%20white%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb021img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 코너패널입니다. 품번 L:86331-7C000 / R:86341-7C000.',
    colors: ['#FFFFFF'],
    features: [
      { icon: 'ri-car-line', title: '순정 디자인', description: '오리지널 스타일' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-sun-line', title: 'UV 내성', description: '변색 방지' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20panel%20production%20facility%20clean%20environment%20professional%20lighting&width=1200&height=800&seq=hdb021craft&orientation=landscape',
      story: '트라고 트럭의 외관을 복원하는 순정 코너패널입니다.',
      details: ['순정 규격 제작', '고강도 플라스틱', 'UV 코팅', '정확한 규격'],
    },
  },
  {
    id: 'HDB022',
    name: 'HDB022',
    partNumber: '81250-7C000 L / 81260-7C000 R',
    description: 'SKIRT',
    price: 68000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20side%20skirt%20black%20plastic%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb022main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20side%20skirt%20black%20plastic%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb022main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20side%20skirt%20black%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb022img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 스커트입니다. 품번 L:81250-7C000 / R:81260-7C000.',
    colors: ['#000000'],
    features: [
      { icon: 'ri-car-line', title: '공기역학', description: '연비 개선' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-sun-line', title: 'UV 내성', description: '변색 방지' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20skirt%20manufacturing%20clean%20factory%20professional%20lighting&width=1200&height=800&seq=hdb022craft&orientation=landscape',
      story: '트라고 트럭의 공기역학을 개선하는 사이드 스커트입니다.',
      details: ['공기역학 설계', '고강도 플라스틱', 'UV 코팅', '정확한 규격'],
    },
  },
  {
    id: 'HDB023',
    name: 'HDB023',
    partNumber: '86920-7C000 L / 86930-7C000 R',
    description: 'SIDE STEP',
    price: 78000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20side%20step%20black%20rubber%20anti%20slip%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb023main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20side%20step%20black%20rubber%20anti%20slip%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb023main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20side%20step%20black%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb023img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 사이드 스텝입니다. 품번 L:86920-7C000 / R:86930-7C000.',
    colors: ['#000000'],
    features: [
      { icon: 'ri-walk-line', title: '미끄럼 방지', description: '안전한 승하차' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-sun-line', title: '내후성', description: '전천후 사용' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20step%20manufacturing%20facility%20clean%20environment%20professional%20lighting&width=1200&height=800&seq=hdb023craft&orientation=landscape',
      story: '트라고 트럭의 안전한 승하차를 위한 사이드 스텝입니다.',
      details: ['미끄럼 방지 처리', '고강도 소재', '순정 규격 제작', '내후성 강화'],
    },
  },
  {
    id: 'HDB025',
    name: 'HDB025',
    partNumber: '86251-7J110',
    description: 'SUNVISOR',
    price: 85000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=professional%20automotive%20sunvisor%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20interior%20sun%20protection%20component%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts&width=800&height=800&seq=hdb025sunvisor&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=professional%20automotive%20sunvisor%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20interior%20sun%20protection%20component%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts&width=800&height=800&seq=hdb025sunvisor&orientation=squarish',
      'https://readdy.ai/api/search-image?query=professional%20automotive%20sunvisor%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20interior%20sun%20protection%20component%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts%20angle%20view&width=800&height=800&seq=hdb025sunvisor2&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: 'HYUNDAI TRAGO HD170-1000 HD-260 전용 선바이저입니다. 운전 중 햇빛 차단을 위한 필수 부품으로, 내구성이 뛰어나며 완벽한 핏을 제공합니다.',
    colors: ['#000000'],
    features: [
      { icon: 'ri-shield-check-line', title: '내구성', description: '고품질 소재 사용' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '순정 규격 완벽 호환' },
      { icon: 'ri-checkbox-circle-line', title: '품질 보증', description: '엄격한 품질 검사' },
      { icon: 'ri-truck-line', title: '빠른 배송', description: '신속한 배송 서비스' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=modern%20automotive%20parts%20manufacturing%20facility%20quality%20control%20inspection%20process%20for%20heavy%20duty%20truck%20components%20professional%20industrial%20environment%20Korean%20factory&width=1200&height=800&seq=hdb025story&orientation=landscape',
      story: 'HYUNDAI TRAGO HD170-1000 HD-260 전용 선바이저는 엄격한 품질 관리를 거쳐 생산됩니다. 내구성과 완벽한 핏을 보장하는 고품질 부품입니다.',
      details: ['순정 규격에 맞춘 정밀 제작', '내구성 테스트 완료', '완벽한 차량 호환성', '장기간 사용 가능한 고품질 소재'],
    },
  },
  {
    id: 'HDB026',
    name: 'HDB026',
    partNumber: '71511-7C000',
    description: 'PANEL',
    price: 95000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=professional%20automotive%20panel%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20exterior%20body%20component%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts&width=800&height=800&seq=hdb026panel&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=professional%20automotive%20panel%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20exterior%20body%20component%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts&width=800&height=800&seq=hdb026panel&orientation=squarish',
      'https://readdy.ai/api/search-image?query=professional%20automotive%20panel%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20exterior%20body%20component%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts%20angle%20view&width=800&height=800&seq=hdb026panel2&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: 'HYUNDAI TRAGO HD170-1000 HD-260 전용 패널입니다. 외관 보호를 위한 고품질 부품으로, 내구성이 뛰어나며 완벽한 핏을 제공합니다.',
    colors: ['#000000'],
    features: [
      { icon: 'ri-shield-check-line', title: '내구성', description: '고품질 소재 사용' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '순정 규격 완벽 호환' },
      { icon: 'ri-checkbox-circle-line', title: '품질 보증', description: '엄격한 품질 검사' },
      { icon: 'ri-truck-line', title: '빠른 배송', description: '신속한 배송 서비스' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=modern%20automotive%20parts%20manufacturing%20facility%20quality%20control%20inspection%20process%20for%20heavy%20duty%20truck%20components%20professional%20industrial%20environment%20Korean%20factory&width=1200&height=800&seq=hdb026story&orientation=landscape',
      story: 'HYUNDAI TRAGO HD170-1000 HD-260 전용 패널은 엄격한 품질 관리를 거쳐 생산됩니다. 내구성과 완벽한 핏을 보장하는 고품질 부품입니다.',
      details: ['순정 규격에 맞춘 정밀 제작', '내구성 테스트 완료', '완벽한 차량 호환성', '장기간 사용 가능한 고품질 소재'],
    },
  },
  {
    id: 'HDB038',
    name: 'HDB038',
    partNumber: '86525-7C000 / 86525-7C100',
    description: 'FRONT BUMPER',
    price: 195000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20front%20bumper%20orange%20painted%20metal%20large%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb038main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20front%20bumper%20orange%20painted%20metal%20large%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb038main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20bumper%20orange%20large%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb038img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 프론트 범퍼입니다. 품번 86525-7C000 / 86525-7C100.',
    colors: ['#FF8C00'],
    features: [
      { icon: 'ri-car-line', title: '고강도 소재', description: '내충격성 우수' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-sun-line', title: 'UV 내성', description: '변색 방지' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20bumper%20manufacturing%20facility%20clean%20environment%20professional%20lighting&width=1200&height=800&seq=hdb038craft&orientation=landscape',
      story: '트라고 트럭의 프론트를 보호하는 고강도 범퍼입니다.',
      details: ['고강도 금속', '순정 규격 제작', '도장 처리', '내충격 설계'],
    },
  },
  {
    id: 'HDB039',
    name: 'HDB039',
    partNumber: 'HDB039',
    description: 'FRONT BUMPER MIDDLE',
    price: 125000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20front%20bumper%20middle%20section%20orange%20painted%20metal%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb039main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20front%20bumper%20middle%20section%20orange%20painted%20metal%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb039main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20bumper%20middle%20orange%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb039img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 프론트 범퍼 미들입니다. 품번 HDB039.',
    colors: ['#FF8C00'],
    features: [
      { icon: 'ri-car-line', title: '고강도 소재', description: '내충격성 우수' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-sun-line', title: 'UV 내성', description: '변색 방지' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20bumper%20manufacturing%20facility%20clean%20environment%20professional%20lighting&width=1200&height=800&seq=hdb039craft&orientation=landscape',
      story: '트라고 트럭의 프론트를 보호하는 범퍼 미들 부품입니다.',
      details: ['고강도 금속', '순정 규격 제작', '도장 처리', '내충격 설계'],
    },
  },
  {
    id: 'HDB040',
    name: 'HDB040',
    partNumber: 'HDB040',
    description: 'FRONT BUMPER',
    price: 210000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20front%20bumper%20orange%20painted%20metal%20complete%20assembly%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb040main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20front%20bumper%20orange%20painted%20metal%20complete%20assembly%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb040main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20bumper%20orange%20complete%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb040img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 프론트 범퍼입니다. 품번 HDB040.',
    colors: ['#FF8C00'],
    features: [
      { icon: 'ri-car-line', title: '고강도 소재', description: '내충격성 우수' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-sun-line', title: 'UV 내성', description: '변색 방지' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20bumper%20manufacturing%20facility%20clean%20environment%20professional%20lighting&width=1200&height=800&seq=hdb040craft&orientation=landscape',
      story: '트라고 트럭의 프론트를 보호하는 고강도 범퍼입니다.',
      details: ['고강도 금속', '순정 규격 제작', '도장 처리', '내충격 설계'],
    },
  },

  // === 3페이지: HDB027~HDB037 ===
  {
    id: 'HDB027',
    name: 'HDB027',
    partNumber: '92101-7A101 L / 92102-7A101 R',
    description: 'HEAD LAMP',
    price: 105000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '램프',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=Hyundai%20Trago%20heavy%20truck%20headlamp%20clear%20lens%20large%20rectangular%20chrome%20housing%20updated%20model%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional%20shot%20detailed&width=800&height=800&seq=hdb027main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=Hyundai%20Trago%20heavy%20truck%20headlamp%20clear%20lens%20large%20rectangular%20chrome%20housing%20updated%20model%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional%20shot%20detailed&width=800&height=800&seq=hdb027main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=heavy%20truck%20headlight%20clear%20lens%20large%20updated%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb027img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '24V',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 헤드램프입니다. 품번 L:92101-7A101 / R:92102-7A101.',
    colors: ['#FFFFFF'],
    features: [
      { icon: 'ri-lightbulb-line', title: '고휘도 조명', description: '야간 시인성 향상' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환성' },
      { icon: 'ri-water-flash-line', title: '방수 설계', description: '우천 시 안전' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20headlamp%20quality%20testing%20laboratory%20clean%20environment%20professional%20lighting&width=1200&height=800&seq=hdb027craft&orientation=landscape',
      story: '트라고 트럭의 안전한 야간 운행을 위한 고품질 헤드램프입니다.',
      details: ['순정 규격 제작', '24V 전용', '내구성 강화 렌즈', '방수 처리 완료'],
    },
  },
  {
    id: 'HDB028',
    name: 'HDB028',
    partNumber: '92301-7A000 L / 92302-7A000 R',
    description: 'CORNER LAMP',
    price: 45000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '램프',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20corner%20lamp%20clear%20lens%20updated%20model%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb028main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20corner%20lamp%20clear%20lens%20updated%20model%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb028main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20corner%20signal%20light%20clear%20updated%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb028img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '24V',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 코너램프입니다. 품번 L:92301-7A000 / R:92302-7A000.',
    colors: ['#FFFFFF'],
    features: [
      { icon: 'ri-lightbulb-line', title: '선명한 신호', description: '안전한 방향지시' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-eye-line', title: '높은 시인성', description: '주야간 선명' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20signal%20lamp%20production%20clean%20factory%20professional%20lighting&width=1200&height=800&seq=hdb028craft&orientation=landscape',
      story: '트라고 트럭의 안전한 방향 전환을 위한 코너램프입니다.',
      details: ['투명 렌즈', '순정 규격 일치', '빠른 점멸 반응', '내구성 보장'],
    },
  },
  {
    id: 'HDB029',
    name: 'HDB029',
    partNumber: '92201-7A100 L / 92202-7A100 R',
    description: 'AUTO LAMP',
    price: 50000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '램프',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20auto%20lamp%20clear%20lens%20updated%20model%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb029main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20auto%20lamp%20clear%20lens%20updated%20model%20on%20clean%20white%20background%20automotive%20lighting%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb029main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20auto%20light%20clear%20updated%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb029img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '24V',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 오토램프입니다. 품번 L:92201-7A100 / R:92202-7A100.',
    colors: ['#FFFFFF'],
    features: [
      { icon: 'ri-lightbulb-line', title: '자동 점등', description: '편리한 사용' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-eye-line', title: '높은 시인성', description: '주야간 선명' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20lamp%20production%20clean%20factory%20professional%20lighting&width=1200&height=800&seq=hdb029craft&orientation=landscape',
      story: '트라고 트럭의 안전한 운행을 위한 오토램프입니다.',
      details: ['자동 점등 기능', '순정 규격 준수', '내구성 강화', '방수 처리 완료'],
    },
  },
  {
    id: 'HDB030',
    name: 'HDB030',
    partNumber: '86510-4E010',
    description: 'BUMPER',
    price: 280000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=professional%20automotive%20front%20bumper%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20exterior%20protection%20component%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts&width=800&height=800&seq=hdb030bumper&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=professional%20automotive%20front%20bumper%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20exterior%20protection%20component%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts&width=800&height=800&seq=hdb030bumper&orientation=squarish',
      'https://readdy.ai/api/search-image?query=professional%20automotive%20front%20bumper%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20exterior%20protection%20component%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts%20angle%20view&width=800&height=800&seq=hdb030bumper2&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: 'HYUNDAI TRAGO HD170-1000 HD-260 전용 범퍼입니다. 차량 전면 보호를 위한 고품질 부품으로, 내구성이 뛰어나며 완벽한 핏을 제공합니다.',
    colors: ['#000000'],
    features: [
      { icon: 'ri-shield-check-line', title: '내구성', description: '고품질 소재 사용' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '순정 규격 완벽 호환' },
      { icon: 'ri-checkbox-circle-line', title: '품질 보증', description: '엄격한 품질 검사' },
      { icon: 'ri-truck-line', title: '빠른 배송', description: '신속한 배송 서비스' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=modern%20automotive%20parts%20manufacturing%20facility%20quality%20control%20inspection%20process%20for%20heavy%20duty%20truck%20components%20professional%20industrial%20environment%20Korean%20factory&width=1200&height=800&seq=hdb030story&orientation=landscape',
      story: 'HYUNDAI TRAGO HD170-1000 HD-260 전용 범퍼는 엄격한 품질 관리를 거쳐 생산됩니다. 내구성과 완벽한 핏을 보장하는 고품질 부품입니다.',
      details: ['순정 규격에 맞춘 정밀 제작', '내구성 테스트 완료', '완벽한 차량 호환성', '장기간 사용 가능한 고품질 소재'],
    },
  },
  {
    id: 'HDB031',
    name: 'HDB031',
    partNumber: '86350-7A002',
    description: 'GRILLE',
    price: 72000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20front%20grille%20black%20large%20center%20mesh%20design%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb031main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20front%20grille%20black%20large%20center%20mesh%20design%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb031main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20grille%20black%20center%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb031img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 그릴입니다. 품번 86350-7A002.',
    colors: ['#000000'],
    features: [
      { icon: 'ri-car-line', title: '순정 디자인', description: '오리지널 스타일' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-sun-line', title: 'UV 내성', description: '변색 방지' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '클립 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20grille%20production%20line%20clean%20factory%20professional%20lighting&width=1200&height=800&seq=hdb031craft&orientation=landscape',
      story: '트라고 트럭의 프론트 외관을 복원하는 순정 그릴입니다.',
      details: ['블랙 마감', '고강도 플라스틱', 'UV 코팅', '정확한 규격'],
    },
  },
  {
    id: 'HDB032',
    name: 'HDB032',
    partNumber: '86355-7A001 L / 86365-7A001 R',
    description: 'GRILLE',
    price: 95000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=professional%20automotive%20side%20grille%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20exterior%20component%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts&width=800&height=800&seq=hdb032grille&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=professional%20automotive%20side%20grille%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20exterior%20component%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts&width=800&height=800&seq=hdb032grille&orientation=squarish',
      'https://readdy.ai/api/search-image?query=professional%20automotive%20side%20grille%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20exterior%20component%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts%20angle%20view&width=800&height=800&seq=hdb032grille2&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: 'HYUNDAI TRAGO HD170-1000 HD-260 전용 사이드 그릴입니다. 외관 보호를 위한 고품질 부품으로, 내구성이 뛰어나며 완벽한 핏을 제공합니다.',
    colors: ['#000000'],
    features: [
      { icon: 'ri-shield-check-line', title: '내구성', description: '고품질 소재 사용' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '순정 규격 완벽 호환' },
      { icon: 'ri-checkbox-circle-line', title: '품질 보증', description: '엄격한 품질 검사' },
      { icon: 'ri-truck-line', title: '빠른 배송', description: '신속한 배송 서비스' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=modern%20automotive%20parts%20manufacturing%20facility%20quality%20control%20inspection%20process%20for%20heavy%20duty%20truck%20components%20professional%20industrial%20environment%20Korean%20factory&width=1200&height=800&seq=hdb032story&orientation=landscape',
      story: 'HYUNDAI TRAGO HD170-1000 HD-260 전용 사이드 그릴은 엄격한 품질 관리를 거쳐 생산됩니다. 내구성과 완벽한 핏을 보장하는 고품질 부품입니다.',
      details: ['순정 규격에 맞춘 정밀 제작', '내구성 테스트 완료', '완벽한 차량 호환성', '장기간 사용 가능한 고품질 소재'],
    },
  },
  {
    id: 'HDB033',
    name: 'HDB033',
    partNumber: '92401-7A100 L / 92402-7A100 R',
    description: 'AUTO LAMP',
    price: 180000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '램프',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=professional%20automotive%20tail%20lamp%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20rear%20lighting%20component%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts&width=800&height=800&seq=hdb033autolamp&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=professional%20automotive%20tail%20lamp%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20rear%20lighting%20component%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts&width=800&height=800&seq=hdb033autolamp&orientation=squarish',
      'https://readdy.ai/api/search-image?query=professional%20automotive%20tail%20lamp%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20rear%20lighting%20component%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts%20angle%20view&width=800&height=800&seq=hdb033autolamp2&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '24V',
    inStock: true,
    status: '재고있음',
    fullDescription: 'HYUNDAI TRAGO HD170-1000 HD-260 전용 테일램프입니다. 후방 조명을 위한 고품질 부품으로, 내구성이 뛰어나며 완벽한 핏을 제공합니다.',
    colors: ['#FF0000'],
    features: [
      { icon: 'ri-shield-check-line', title: '내구성', description: '고품질 소재 사용' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '순정 규격 완벽 호환' },
      { icon: 'ri-checkbox-circle-line', title: '품질 보증', description: '엄격한 품질 검사' },
      { icon: 'ri-truck-line', title: '빠른 배송', description: '신속한 배송 서비스' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=modern%20automotive%20parts%20manufacturing%20facility%20quality%20control%20inspection%20process%20for%20heavy%20duty%20truck%20components%20professional%20industrial%20environment%20Korean%20factory&width=1200&height=800&seq=hdb033story&orientation=landscape',
      story: 'HYUNDAI TRAGO HD170-1000 HD-260 전용 테일램프는 엄격한 품질 관리를 거쳐 생산됩니다. 내구성과 완벽한 핏을 보장하는 고품질 부품입니다.',
      details: ['순정 규격에 맞춘 정밀 제작', '내구성 테스트 완료', '완벽한 차량 호환성', '장기간 사용 가능한 고품질 소재'],
    },
  },
  {
    id: 'HDB033LED',
    name: 'HDB033LED',
    partNumber: 'HDB033LED',
    description: 'TAIL LAMP LED',
    price: 220000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '램프',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=professional%20automotive%20LED%20tail%20lamp%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20rear%20lighting%20component%20modern%20design%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts&width=800&height=800&seq=hdb033led&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=professional%20automotive%20LED%20tail%20lamp%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20rear%20lighting%20component%20modern%20design%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts&width=800&height=800&seq=hdb033led&orientation=squarish',
      'https://readdy.ai/api/search-image?query=professional%20automotive%20LED%20tail%20lamp%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20rear%20lighting%20component%20modern%20design%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts%20angle%20view&width=800&height=800&seq=hdb033led2&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '24V',
    inStock: true,
    status: '재고있음',
    fullDescription: 'HYUNDAI TRAGO HD170-1000 HD-260 전용 LED 테일램프입니다. 최신 LED 기술로 밝고 선명한 후방 조명을 제공합니다.',
    colors: ['#FF0000'],
    features: [
      { icon: 'ri-lightbulb-line', title: 'LED 조명', description: '초고휘도' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-flashlight-line', title: '저전력', description: '에너지 절약' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=LED%20truck%20lamp%20testing%20facility%20clean%20environment%20professional%20lighting&width=1200&height=800&seq=hdb033ledcraft&orientation=landscape',
      story: '트라고 트럭의 후방 안전을 위한 최신 LED 테일램프입니다.',
      details: ['LED 초고휘도', '저전력 소비', '장수명 설계', '방수 처리 완료'],
    },
  },
  {
    id: 'HDB034',
    name: 'HDB034',
    partNumber: '82710-7A000 L / 82720-7A000 R',
    description: 'CORNER PANEL',
    price: 85000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20corner%20panel%20white%20plastic%20updated%20model%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb034main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20corner%20panel%20white%20plastic%20updated%20model%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb034main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20corner%20panel%20white%20updated%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb034img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 코너패널입니다. 품번 L:82710-7A000 / R:82720-7A000.',
    colors: ['#FFFFFF'],
    features: [
      { icon: 'ri-car-line', title: '순정 디자인', description: '오리지널 스타일' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-sun-line', title: 'UV 내성', description: '변색 방지' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20panel%20production%20facility%20clean%20environment%20professional%20lighting&width=1200&height=800&seq=hdb034craft&orientation=landscape',
      story: '트라고 트럭의 외관을 복원하는 순정 코너패널입니다.',
      details: ['순정 규격 제작', '고강도 플라스틱', 'UV 코팅', '정확한 규격'],
    },
  },
  {
    id: 'HDB035',
    name: 'HDB035',
    partNumber: '86375-7A001 L / 86385-7A001 R',
    description: 'GARNISH PANEL',
    price: 85000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=professional%20automotive%20garnish%20panel%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20exterior%20trim%20component%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts&width=800&height=800&seq=hdb035garnish&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=professional%20automotive%20garnish%20panel%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20exterior%20trim%20component%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts&width=800&height=800&seq=hdb035garnish&orientation=squarish',
      'https://readdy.ai/api/search-image?query=professional%20automotive%20garnish%20panel%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20exterior%20trim%20component%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts%20angle%20view&width=800&height=800&seq=hdb035garnish2&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: 'HYUNDAI TRAGO HD170-1000 HD-260 전용 가니쉬 패널입니다. 외관 마감을 위한 고품질 부품으로, 내구성이 뛰어나며 완벽한 핏을 제공합니다.',
    colors: ['#000000'],
    features: [
      { icon: 'ri-shield-check-line', title: '내구성', description: '고품질 소재 사용' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '순정 규격 완벽 호환' },
      { icon: 'ri-checkbox-circle-line', title: '품질 보증', description: '엄격한 품질 검사' },
      { icon: 'ri-truck-line', title: '빠른 배송', description: '신속한 배송 서비스' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=modern%20automotive%20parts%20manufacturing%20facility%20quality%20control%20inspection%20process%20for%20heavy%20duty%20truck%20components%20professional%20industrial%20environment%20Korean%20factory&width=1200&height=800&seq=hdb035story&orientation=landscape',
      story: 'HYUNDAI TRAGO HD170-1000 HD-260 전용 가니쉬 패널은 엄격한 품질 관리를 거쳐 생산됩니다. 내구성과 완벽한 핏을 보장하는 고품질 부품입니다.',
      details: ['순정 규격에 맞춘 정밀 제작', '내구성 테스트 완료', '완벽한 차량 호환성', '장기간 사용 가능한 고품질 소재'],
    },
  },
  {
    id: 'HDB036',
    name: 'HDB036',
    partNumber: '81265-7A000',
    description: 'GARNISH PANEL',
    price: 75000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=professional%20automotive%20lower%20garnish%20panel%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20exterior%20trim%20component%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts&width=800&height=800&seq=hdb036garnish&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=professional%20automotive%20lower%20garnish%20panel%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20exterior%20trim%20component%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts&width=800&height=800&seq=hdb036garnish&orientation=squarish',
      'https://readdy.ai/api/search-image?query=professional%20automotive%20lower%20garnish%20panel%20for%20heavy%20duty%20truck%20HYUNDAI%20TRAGO%20HD170-1000%20HD-260%20exterior%20trim%20component%20clean%20white%20background%20product%20photography%20Korean%20auto%20parts%20angle%20view&width=800&height=800&seq=hdb036garnish2&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: 'HYUNDAI TRAGO HD170-1000 HD-260 전용 하단 가니쉬 패널입니다. 외관 마감을 위한 고품질 부품으로, 내구성이 뛰어나며 완벽한 핏을 제공합니다.',
    colors: ['#000000'],
    features: [
      { icon: 'ri-shield-check-line', title: '내구성', description: '고품질 소재 사용' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '순정 규격 완벽 호환' },
      { icon: 'ri-checkbox-circle-line', title: '품질 보증', description: '엄격한 품질 검사' },
      { icon: 'ri-truck-line', title: '빠른 배송', description: '신속한 배송 서비스' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=modern%20automotive%20parts%20manufacturing%20facility%20quality%20control%20inspection%20process%20for%20heavy%20duty%20truck%20components%20professional%20industrial%20environment%20Korean%20factory&width=1200&height=800&seq=hdb036story&orientation=landscape',
      story: 'HYUNDAI TRAGO HD170-1000 HD-260 전용 하단 가니쉬 패널은 엄격한 품질 관리를 거쳐 생산됩니다. 내구성과 완벽한 핏을 보장하는 고품질 부품입니다.',
      details: ['순정 규격에 맞춘 정밀 제작', '내구성 테스트 완료', '완벽한 차량 호환성', '장기간 사용 가능한 고품질 소재'],
    },
  },
  {
    id: 'HDB037',
    name: 'HDB037',
    partNumber: '86910-7A001 L / 86920-7A001 R',
    description: 'SIDE STEP',
    price: 82000,
    category: 'HYUNDAI TRAGO HD170-1000 HD-260',
    subcategory: '외장',
    vehicleBrand: 'HYUNDAI',
    image: 'https://readdy.ai/api/search-image?query=heavy%20truck%20side%20step%20black%20rubber%20anti%20slip%20updated%20model%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb037main&orientation=squarish',
    images: [
      'https://readdy.ai/api/search-image?query=heavy%20truck%20side%20step%20black%20rubber%20anti%20slip%20updated%20model%20on%20clean%20white%20background%20automotive%20exterior%20spare%20part%20product%20photography%20studio%20lighting%20professional&width=800&height=800&seq=hdb037main&orientation=squarish',
      'https://readdy.ai/api/search-image?query=truck%20side%20step%20black%20updated%20on%20white%20background%20automotive%20product%20photography%20professional%20lighting&width=800&height=800&seq=hdb037img1&orientation=squarish',
    ],
    compatibleVehicles: ['HYUNDAI TRAGO HD170-1000', 'HYUNDAI TRAGO HD-260'],
    voltage: '-',
    inStock: true,
    status: '재고있음',
    fullDescription: '현대 트라고 트럭에 호환되는 사이드 스텝입니다. 품번 L:86910-7A001 / R:86920-7A001.',
    colors: ['#000000'],
    features: [
      { icon: 'ri-walk-line', title: '미끄럼 방지', description: '안전한 승하차' },
      { icon: 'ri-shield-check-line', title: '순정 규격', description: '완벽한 호환' },
      { icon: 'ri-sun-line', title: '내후성', description: '전천후 사용' },
      { icon: 'ri-tools-line', title: '간편 설치', description: '볼트온 장착' },
    ],
    craftStory: {
      image: 'https://readdy.ai/api/search-image?query=truck%20step%20manufacturing%20facility%20clean%20environment%20professional%20lighting&width=1200&height=800&seq=hdb037craft&orientation=landscape',
      story: '트라고 트럭의 안전한 승하차를 위한 사이드 스텝입니다.',
      details: ['미끄럼 방지 처리', '고강도 소재', '순정 규격 제작', '내후성 강화'],
    },
  },
];
